<div class="d-flex min-vh-75 w-100 flex-column justify-content-center">
    <div class="">                    
        <p class="fw-semi-bold">(9 of 10) Overall Well-being</p>
        <div class="progress" style="height:8px">
        <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
    <div class="flex-grow-1 "></div>
    <div class="d-flex d-flex justify-content-center">

        <div class="assessment-block">
            
            <p class="question-header">How would you rate your overall well-being and satisfaction with your diabetes management?</p>            
            <div class="form-check ps-10 pe-10">
                <input [(ngModel)]="assessment.overallWellBeingQ1" class="btn-check" id="q1" type="radio" name="question1" value="Excellent" (change)="onChange()"/>        
                <label class="btn btn-small btn-outline-secondary w-100" for="q1">Excellent</label>
            </div>
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.overallWellBeingQ1" class="btn-check" id="q2" type="radio" name="question1" value="Good" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q2">Good</label>
            </div> 
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.overallWellBeingQ1" class="btn-check" id="q3" type="radio" name="question1" value="Fair" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q3">Fair</label>
            </div> 
            <div class="form-check ps-10 pe-10">        
                <input [(ngModel)]="assessment.overallWellBeingQ1" class="btn-check" id="q4" type="radio" name="question1" value="Poor" (change)="onChange()"/>
                <label class="btn btn-outline-secondary w-100" for="q4">Poor</label>
            </div>            

                   

        </div>
    </div>
    <div class="p-2 flex-grow-1"></div>
    
    <div class="d-flex mb-2">
        <div class="me-auto p-2">
            <button class="btn btn-link" (click)="_prevButton()" type="submit">Prev</button>
        </div>
        <div class="p-2">
        <button class="btn btn-link" (click)="_nextButton()" type="submit">Skip</button>
        </div>
        <div class="p-2">
        <button class="btn btn-primary" (click)="_nextButton()" type="submit">Next</button>
        </div>
    </div>
</div>
